import JSONPretty from 'react-json-pretty';

export default {
  className: "PointsWalletAPILogs",
  limit: 10,
  showExport: false,
  showCreate: false,
  showUpdate: false,
  showDelete: false,
  bypassAccess: true,
  columns: [
    {
      columnName: "objectId",
  		type: "string"
    },
    {
      columnName: "memberId",
  		type: "string"
    },
    {
      columnName: "status",
  		type: "string"
    },
    {
      columnName: "createdAt",
      columnLabel: "Date",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A",
      show: true
    },
    {
      columnName: "updatedAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    }
  ]
}


// WEBPACK FOOTER //
// ./components/Logs/PointsWalletAPILogs_schema.js